import useActiveOrdersContext from '@/contexts/activeOrders/useActiveOrdersContext'
import { getScheduledOrdersKanban } from '@/pages/ScheduledOrders/utils'
import { OrderStatus } from '@/resources/enums'
import { NotificationType } from '@/resources/enums/orders'
import { Interval } from '@/resources/types/websocket'
import {
  getNotificationType,
  hasPendingOrders,
  updateScheduledOrdersNotificationTracking,
  validateTurboOrders,
} from '@/resources/utils/orders/notification'
import { CHECK_ORDERS_POLLING_TIME } from '@/seller.application.polling.time.config'
import { useEffect, useMemo, useRef, useState } from 'react'
import OrderBell, { OrderRef } from '../OrderBell'

const CheckOrders = () => {
  const { activeOrders, isPollingActive, isFromWss, isQueryFetching } =
    useActiveOrdersContext()
  const bellRef = useRef<OrderRef>(null)
  const turboPendingRef = useRef<string[]>([])
  const notificationIntervalRef = useRef<Interval>(null)
  const [checkOrders, setCheckOrders] = useState<boolean>(false)

  const { hasPending, hasTurbo } = useMemo(
    () => hasPendingOrders(activeOrders),
    [activeOrders]
  )

  const acceptedScheduledOrders = useMemo(
    () =>
      getScheduledOrdersKanban({
        orders: activeOrders,
        includedStatus: [OrderStatus.POC_ACCEPTED, OrderStatus.DM_ACCEPTED],
      }),
    [activeOrders]
  )

  if (checkOrders) {
    setCheckOrders(false)
    if (hasPending || hasTurbo) {
      bellRef.current?.playAudio(getNotificationType(hasTurbo))
    } else if (acceptedScheduledOrders.length > 0) {
      const shouldPlayScheduledAudio =
        updateScheduledOrdersNotificationTracking(acceptedScheduledOrders)
      if (shouldPlayScheduledAudio) {
        bellRef.current?.playAudio(NotificationType.SCHEDULED)
      }
    }
  }

  if (!isPollingActive && !notificationIntervalRef.current) {
    notificationIntervalRef.current = setInterval(
      () => setCheckOrders(true),
      CHECK_ORDERS_POLLING_TIME
    )
  }

  useEffect(() => {
    if (isPollingActive && notificationIntervalRef.current) {
      clearInterval(notificationIntervalRef.current)
    }
  }, [isPollingActive])

  useEffect(() => {
    if (isFromWss) {
      const hasNewTurboOrders = validateTurboOrders(
        activeOrders,
        turboPendingRef
      )

      if (hasNewTurboOrders) {
        bellRef.current?.playAudio(NotificationType.TURBO)
      }
    } else if (!isQueryFetching && activeOrders) {
      setCheckOrders(true)
    }
  }, [isQueryFetching, isFromWss, activeOrders])

  return <OrderBell ref={bellRef} />
}

export default CheckOrders
